<template>
  <f7-page id="login-singpass-callback" name="login-singpass-callback" @page:afterin="afterin">
    <f7-block>
    </f7-block>
  </f7-page>
</template>

<script>
  export default {
    mounted (){
      this.showPreloader();
      /*
      if(window.location.host == "wandrepartner.p2hdevworks.com"){ // stg axs: wandrepartner.p2hdevworks.com, stg wandr-e: wandre.p2hdevworks.com
        window.location.host = "wandre.p2hdevworks.com";
      }else if(window.location.host == "partner.wandr-e.com"){ // prod
        window.location.host = "sendmoney.wandr-e.com";
      }
      */

      this.code  = this.$f7route.query['code'] || '';
      this.state = this.$f7route.query['state'] || '';
      this.singpassLogin();
    },
    data() {
      return {
        code   : '',
        state  : ''
      };
    },
    methods: {
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      singpassLogin() {
        if (!window.opener) {
          // No live opener reference at all - some mobile WebViews lose this even for a
          // same-origin window.open()-created popup, so window.opener/postMessage can
          // never work here regardless of origin. Hand off via localStorage instead: any
          // other same-origin tab/window gets a 'storage' event without needing an
          // opener/popup object reference, then self-close so we don't strand the user
          // on this blank page.
          this.broadcastViaLocalStorage();
          return;
        }
        try {
          // Same-origin: direct call
          window.opener.singpassLoginCallback(this.state, this.code);
        } catch (e) {
          // Cross-origin (AXS domain vs callback domain): fall back to postMessage
          const openerOrigin = process.env.VUE_APP_SINGPASS_OPENER_ORIGIN || window.location.origin;
          window.opener.postMessage(
            { type: 'singpassCallback', state: this.state, code: this.code },
            openerOrigin
          );
        }
      },
      broadcastViaLocalStorage() {
        try {
          localStorage.setItem('singpassCallbackPending', JSON.stringify({ state: this.state, code: this.code }));
        } catch (e) {
          // localStorage unavailable (private mode, quota, etc.) - nothing more we can do here
        }
        try {
          window.close();
        } catch (e) {
          // some WebViews refuse to close a window they didn't script-open; nothing more we can do
        }
      },
    },
    components: {
      
    },
    computed: {
      
    },
  }
</script>